import React from 'react'
import PropTypes from 'prop-types'

const Label = ({ label, labelClassName = '' }) => {
    return (<label className={'control-label ' + labelClassName}>{label}</label>)
}

const GroupAddOn = ({ groupAddOnIcon }) => {
    if (!groupAddOnIcon) {
        return null
    }
    return (<span className="input-group-addon"><i className={groupAddOnIcon}/></span>)
}

const ActionAddOn = ({ actionAddOnIcon, onActionAddOnClick }) => {
    if (!actionAddOnIcon) {
        return null
    }
    return (
        <span className="input-group-btn">
            <button className="btn btn-primary" onClick={onActionAddOnClick} type="button">
                <i className={actionAddOnIcon}/>
            </button>
        </span>
    )
}


const LabelInput = (props) => {
    const isGroup = props.groupAddOnIcon || props.actionAddOnIcon
    if (!isGroup) {
        return (
            <div>
                <Label {...props}/>
                {props.children}
            </div>
        )
    }

    return (
        <div>
            <Label {...props}/>
            <div className="input-group">
                <GroupAddOn {...props}/>
                {props.children}
                <ActionAddOn {...props}/>
            </div>
        </div>
    )
}

LabelInput.propTypes = {
    label: PropTypes.string.isRequired,
    labelClassName: PropTypes.string,
    groupAddOnIcon: PropTypes.string,
    actionAddOnIcon: PropTypes.string,
    onActionAddOnClick: PropTypes.func,
}


export default LabelInput



// WEBPACK FOOTER //
// ./src/modules/form/component/LabelInput.js